import { ActionContext, ActionTree } from 'vuex';
import ApiService from '@/services/ApiService';
import { ActionTypes as CommonActionTypes } from '../Common/actions';

import { RootState } from '@/store';
import { State } from './state';
import router from '@/router';

import { Mutations, MutationTypes } from './mutations';

import { AuthUser, LoginRequest, RefreshLoginRequest, LogoutRequest } from '@/models/AuthModels';
import { ErrorResponseData } from '@/models/Common/CommonModels';

export enum ActionTypes {
  Login = 'LOGIN',
  RefreshLogin = 'REFRESHLOGIN',
  Logout = 'LOGOUT',
}

type ActionArguments = Omit<ActionContext<State, RootState>, 'commit'> & {
  commit<K extends keyof Mutations>(key: K, payload: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>;
};

export type Actions = {
  [ActionTypes.Login](context: ActionArguments, data: LoginRequest): Promise<void>;
  [ActionTypes.RefreshLogin](context: ActionArguments): Promise<void>;
  [ActionTypes.Logout](context: ActionArguments): Promise<void>;
};

export const actions: ActionTree<State, RootState> & Actions = {
  async [ActionTypes.Login]({ commit, dispatch, rootGetters }: ActionArguments, data: LoginRequest) {
    const status = rootGetters.status;
    status.authLoading = true;
    status.authErrorMsg = '';
    dispatch(CommonActionTypes.SetStatus, status);

    return ApiService.login(data)
      .then((res) => {
        const user: AuthUser = res.data;
        commit(MutationTypes.LoginSuccess, user);
        router.push({ name: 'Versender' });
      })
      .catch((error) => {
        console.log(error);
        var errorresponse = (error.response?.data as ErrorResponseData) || null;
        status.authErrorMsg = errorresponse != null ? errorresponse.title : error.response;
      })
      .finally(() => {
        status.authLoading = false;
        dispatch(CommonActionTypes.SetStatus, status);
      });
  },

  async [ActionTypes.RefreshLogin]({ commit, rootGetters }: ActionArguments) {
    const request = new RefreshLoginRequest(rootGetters.authUser.refreshToken);
    return ApiService.refreshLogin(request).then((res) => {
      const result: AuthUser = res.data;
      commit(MutationTypes.RefreshLoginSuccess, result);
    });
  },

  async [ActionTypes.Logout]({ commit, dispatch, rootGetters }: ActionArguments) {
    const status = rootGetters.status;
    status.authLoading = true;
    status.authErrorMsg = '';
    dispatch(CommonActionTypes.SetStatus, status);

    var data = new LogoutRequest(rootGetters.authUser.refreshToken);
    return ApiService.logout(data)
      .then(() => {
        console.log('LOGOUT');
      })
      .catch((error) => {
        console.log('LOGOUT CATCH');
        console.log(error);
      })
      .finally(async () => {
        commit(MutationTypes.Logout, undefined);

        status.authLoading = false;
        dispatch(CommonActionTypes.SetStatus, status);

        localStorage.clear();
      });
  },
};
